import { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { supabase } from "@/shared/integrations/supabase/client";
import PageHeader from "@/shared/components/PageHeader";
import DocumentosInstituicao from "@/interno/instituicoes/componentes/DocumentosInstituicao";
import { tituloExibicaoInstituicao } from "@/interno/instituicoes/lib/instituicaoCamposSeguros";

interface Institution {
  id: string;
  name: string;
  type: string;
  razao_social: string | null;
  nome_fantasia: string | null;
}

const DocumentosInstituicaoPagina = () => {
  const { id } = useParams<{ id: string }>();
  const [institution, setInstitution] = useState<Institution | null>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!id) {
      setInstitution(null);
      setLoading(false);
      return;
    }
    let cancelled = false;
    setLoading(true);
    setInstitution(null);
    void supabase
      .from("institutions")
      .select("id, name, type, razao_social, nome_fantasia")
      .eq("id", id)
      .maybeSingle()
      .then(({ data, error }) => {
        if (cancelled) return;
        if (error) {
          console.warn("[DocumentosInstituicaoPagina] institutions", error);
          setInstitution(null);
          setLoading(false);
          return;
        }
        setInstitution((data ?? null) as Institution | null);
        setLoading(false);
      })
      .catch((err: unknown) => {
        if (cancelled) return;
        console.warn("[DocumentosInstituicaoPagina] institutions catch", err);
        setInstitution(null);
        setLoading(false);
      });
    return () => {
      cancelled = true;
    };
  }, [id]);

  if (loading) {
    return (
      <div className="flex items-center justify-center py-12">
        <Loader2 className="h-6 w-6 animate-spin text-primary" />
      </div>
    );
  }

  if (!institution) {
    return (
      <div className="space-y-6">
        <PageHeader title="Sem acesso" backTo="/dashboard/institutions" />
        <p className="text-muted-foreground text-center py-8 max-w-lg mx-auto text-sm leading-relaxed">
          Não foi possível carregar esta instituição ou o seu usuário não está na equipe jurídica vinculada a ela.
        </p>
      </div>
    );
  }

  const displayName = tituloExibicaoInstituicao(institution);
  const backTo = `/dashboard/institutions/${id}`;

  return (
    <div className="space-y-6">
      <PageHeader
        title={displayName}
        subtitle="Documentos da instituição"
        backTo={backTo}
      />
      <DocumentosInstituicao institutionId={id!} institutionName={displayName} />
    </div>
  );
};

export default DocumentosInstituicaoPagina;
